import { render, staticRenderFns } from "./PickRecord.vue?vue&type=template&id=74d540db&scoped=true"
import script from "./PickRecord.vue?vue&type=script&lang=js"
export * from "./PickRecord.vue?vue&type=script&lang=js"
import style0 from "./PickRecord.vue?vue&type=style&index=0&id=74d540db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d540db",
  null
  
)

export default component.exports